// import lang from "@/views/modules/ExpressionInterests/language/en";

let metaList = [];
const link_list = {
    routePath: 'exinterests',
    customDashlet: 'Active',
    title: 'Recent Active Intent To Submit',
    search: {
        status: {
                key:'status',
                value:['Active'],
            },
        },
    sort: {
        order: 'desc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { metaList, link_list }